function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var SaitoOverlay = require('../../../../../lib/saito/ui/saito-overlay/saito-overlay');
var DelistOverlayTemplate = require('./delist-overlay.template');
var Summary = require('../../summary');
var _require = require('../../summary'),
  DREAMSCAPE_PLACEHOLDER = _require.DREAMSCAPE_PLACEHOLDER;
var _require2 = require('../../archive'),
  loadTransactionFromArchive = _require2.loadTransactionFromArchive;
var _require3 = require('../../categories'),
  isStoreRentalListing = _require3.isStoreRentalListing;
function loadListingSpend(app, mod) {
  var signature = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  return new Promise(function (resolve, reject) {
    var _app$network;
    var peerKey = mod.store_public_key;
    var sig = String(signature || '').trim();
    if (!sig) {
      reject(new Error('Listing signature required'));
      return;
    }
    if (!peerKey || !(app !== null && app !== void 0 && (_app$network = app.network) !== null && _app$network !== void 0 && _app$network.sendRequestAsTransaction)) {
      reject(new Error('Store peer unavailable'));
      return;
    }
    app.network.sendRequestAsTransaction('load-listing-spend', {
      module: 'Store',
      signature: sig
    }, function (response) {
      if (!(response !== null && response !== void 0 && response.signature) || !(response !== null && response !== void 0 && response.access_script)) {
        reject(new Error('Listing spend data unavailable'));
        return;
      }
      resolve(response);
    }, peerKey);
  });
}
var DelistOverlay = /*#__PURE__*/function () {
  function DelistOverlay(app, mod) {
    var _this = this;
    _classCallCheck(this, DelistOverlay);
    this.app = app;
    this.mod = mod;
    this.overlay = new SaitoOverlay(app, mod);
    this.summary = null;
    this.busy = false;
    this.app.connection.on('store-delist-asset', function (data) {
      _this.onStoreDelistAsset(data);
    });
  }
  return _createClass(DelistOverlay, [{
    key: "escapeHtml",
    value: function escapeHtml() {
      var _this$app;
      var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      if ((_this$app = this.app) !== null && _this$app !== void 0 && (_this$app = _this$app.browser) !== null && _this$app !== void 0 && _this$app.escapeHTML) {
        return this.app.browser.escapeHTML(String(value));
      }
      return String(value).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
    }
  }, {
    key: "hasCurrencyLabel",
    value: function hasCurrencyLabel() {
      var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      return /[a-zA-Z]/.test(String(value));
    }
  }, {
    key: "returnCreatedDate",
    value: function returnCreatedDate() {
      var summary = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var raw = summary.created_at || summary.createdAt || summary.timestamp || Date.now();
      var date = new Date(raw);
      if (Number.isNaN(date.getTime())) {
        return new Date().toLocaleDateString();
      }
      return date.toLocaleDateString();
    }
  }, {
    key: "returnProductType",
    value: function returnProductType() {
      var summary = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      if (summary.type) {
        return summary.type;
      }
      if (summary.nft || summary.nft_id || summary.badge) {
        return 'NFT';
      }
      return 'Digital';
    }
  }, {
    key: "returnListingMeta",
    value: function returnListingMeta() {
      var _tx$returnMessage;
      var summary = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var tx = summary.listing_tx;
      var txmsg = (tx === null || tx === void 0 || (_tx$returnMessage = tx.returnMessage) === null || _tx$returnMessage === void 0 ? void 0 : _tx$returnMessage.call(tx)) || (tx === null || tx === void 0 ? void 0 : tx.msg) || {};
      return txmsg.listing || {};
    }
  }, {
    key: "returnViewModel",
    value: function returnViewModel() {
      var _summary$returnTitle,
        _summary$returnMediaD,
        _summary$hasLoadedIma,
        _summary$returnImage,
        _summary$returnPlaceh,
        _this2 = this,
        _summary$returnPrice,
        _summary$returnDescri,
        _ref,
        _ref2,
        _summary$quantity_tot,
        _summary$returnQuanti,
        _this$app2,
        _this$app2$returnIden,
        _summary$isImageLoadi,
        _summary$isImageLoadi2;
      var summary = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var listingTitle = this.escapeHtml(((_summary$returnTitle = summary.returnTitle) === null || _summary$returnTitle === void 0 ? void 0 : _summary$returnTitle.call(summary)) || 'Untitled Item');
      var seller = summary.seller || 'anon-store';
      var display = ((_summary$returnMediaD = summary.returnMediaDisplay) === null || _summary$returnMediaD === void 0 ? void 0 : _summary$returnMediaD.call(summary)) || {};
      var listingImage = display.backgroundImage || ((_summary$hasLoadedIma = summary.hasLoadedImage) !== null && _summary$hasLoadedIma !== void 0 && _summary$hasLoadedIma.call(summary) ? ((_summary$returnImage = summary.returnImage) === null || _summary$returnImage === void 0 ? void 0 : _summary$returnImage.call(summary)) || '' : '');
      var placeholder = display.loading || display.innerHtml ? '' : ((_summary$returnPlaceh = summary.returnPlaceholderImage) === null || _summary$returnPlaceh === void 0 ? void 0 : _summary$returnPlaceh.call(summary)) || DREAMSCAPE_PLACEHOLDER;
      var rawImages = [listingImage || placeholder].filter(Boolean);
      var normalizedImages = rawImages.filter(function (src) {
        var _this2$app, _this2$app$isSafeMedi;
        return (_this2$app = _this2.app) === null || _this2$app === void 0 || (_this2$app = _this2$app.browser) === null || _this2$app === void 0 || (_this2$app$isSafeMedi = _this2$app.isSafeMediaUrl) === null || _this2$app$isSafeMedi === void 0 ? void 0 : _this2$app$isSafeMedi.call(_this2$app, src);
      }).map(function (src) {
        return _this2.escapeHtml(src);
      });
      if (!normalizedImages.length) {
        normalizedImages.push(this.escapeHtml(DREAMSCAPE_PLACEHOLDER));
      }
      var listingMeta = this.returnListingMeta(summary);
      var isRental = isStoreRentalListing(summary, listingMeta);
      var priceValue = ((_summary$returnPrice = summary.returnPrice) === null || _summary$returnPrice === void 0 ? void 0 : _summary$returnPrice.call(summary)) || summary.price || '';
      var currency = summary.currency || summary.denomination || 'SAITO';
      var primaryDisplay = this.escapeHtml(this.hasCurrencyLabel(priceValue) ? String(priceValue) : "".concat(priceValue || 'N/A', " ").concat(currency));
      var description = this.escapeHtml(((_summary$returnDescri = summary.returnDescription) === null || _summary$returnDescri === void 0 ? void 0 : _summary$returnDescri.call(summary)) || '');
      var supply = Number((_ref = (_ref2 = (_summary$quantity_tot = summary.quantity_total) !== null && _summary$quantity_tot !== void 0 ? _summary$quantity_tot : (_summary$returnQuanti = summary.returnQuantity) === null || _summary$returnQuanti === void 0 ? void 0 : _summary$returnQuanti.call(summary)) !== null && _ref2 !== void 0 ? _ref2 : summary.quantity_available) !== null && _ref !== void 0 ? _ref : 1) || 1;
      return {
        identicon: this.escapeHtml(((_this$app2 = this.app) === null || _this$app2 === void 0 || (_this$app2 = _this$app2.keychain) === null || _this$app2 === void 0 || (_this$app2$returnIden = _this$app2.returnIdenticon) === null || _this$app2$returnIden === void 0 ? void 0 : _this$app2$returnIden.call(_this$app2, seller)) || ''),
        listingTitle: listingTitle,
        seller: this.escapeHtml(seller),
        images: normalizedImages,
        primaryLabel: this.escapeHtml(isRental ? 'Rental Price' : 'Price'),
        primaryDisplay: primaryDisplay,
        supply: supply,
        description: description,
        hasDescription: !!description,
        productType: this.escapeHtml(isRental ? 'store-nft-rental' : this.returnProductType(summary)),
        createdDate: this.escapeHtml(this.returnCreatedDate(summary)),
        imageLoading: (_summary$isImageLoadi = (_summary$isImageLoadi2 = summary.isImageLoading) === null || _summary$isImageLoadi2 === void 0 ? void 0 : _summary$isImageLoadi2.call(summary)) !== null && _summary$isImageLoadi !== void 0 ? _summary$isImageLoadi : false
      };
    }
  }, {
    key: "open",
    value: function open(summary) {
      var _this3 = this,
        _summary$isImageLoadi4;
      if (!(summary instanceof Summary) || !summary.listing_signature) {
        return;
      }
      this.summary = summary;
      this.render(summary);
      var finish = function finish() {
        var _this3$overlay;
        if ((_this3$overlay = _this3.overlay) !== null && _this3$overlay !== void 0 && _this3$overlay.visible && _this3.summary === summary) {
          _this3.render(summary);
        }
      };
      if (!summary.listing_tx && summary.listing_signature) {
        summary.ensureListingTransaction(function () {
          var _summary$isImageLoadi3;
          if ((_summary$isImageLoadi3 = summary.isImageLoading) !== null && _summary$isImageLoadi3 !== void 0 && _summary$isImageLoadi3.call(summary)) {
            summary.enrichMedia(finish);
            return;
          }
          finish();
        });
        return;
      }
      if ((_summary$isImageLoadi4 = summary.isImageLoading) !== null && _summary$isImageLoadi4 !== void 0 && _summary$isImageLoadi4.call(summary)) {
        summary.enrichMedia(finish);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var summary = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.summary;
      if (!(summary instanceof Summary)) {
        return;
      }
      this.summary = summary;
      this.overlay.show(DelistOverlayTemplate.viewTemplate(this.returnViewModel(summary)));
      this.attachEvents();
      this.applyProductMedia(summary);
    }
  }, {
    key: "applyProductMedia",
    value: function applyProductMedia() {
      var _summary$returnMediaD2;
      var summary = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.summary;
      if (!(summary instanceof Summary)) {
        return;
      }
      var display = ((_summary$returnMediaD2 = summary.returnMediaDisplay) === null || _summary$returnMediaD2 === void 0 ? void 0 : _summary$returnMediaD2.call(summary)) || {};
      var media = document.querySelector('.listing-detail.delist .media');
      var mainImage = document.querySelector('.listing-detail.delist .image');
      if (!media) {
        return;
      }
      var content = media.querySelector('.media-content');
      if (display.loading) {
        return;
      }
      if (display.innerHtml) {
        if (mainImage) {
          mainImage.style.display = 'none';
        }
        if (!content) {
          content = document.createElement('div');
          content.className = 'media-content';
          media.appendChild(content);
        }
        content.innerHTML = display.innerHtml;
        return;
      }
      if (content) {
        content.remove();
      }
      if (mainImage) {
        var _this$app3, _this$app3$isSafeMedi;
        mainImage.style.display = '';
        if (display.backgroundImage && (_this$app3 = this.app) !== null && _this$app3 !== void 0 && (_this$app3 = _this$app3.browser) !== null && _this$app3 !== void 0 && (_this$app3$isSafeMedi = _this$app3.isSafeMediaUrl) !== null && _this$app3$isSafeMedi !== void 0 && _this$app3$isSafeMedi.call(_this$app3, display.backgroundImage)) {
          mainImage.setAttribute('src', display.backgroundImage);
        }
      }
    }
  }, {
    key: "attachEvents",
    value: function attachEvents() {
      var _this4 = this;
      var root = document.querySelector('.listing-detail.delist');
      if (!root) {
        return;
      }
      var delistBtn = root.querySelector('[data-action="delist"]');
      if (!delistBtn) {
        return;
      }
      delistBtn.onclick = /*#__PURE__*/function () {
        var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(e) {
          var _t;
          return _regenerator().w(function (_context) {
            while (1) switch (_context.p = _context.n) {
              case 0:
                e.preventDefault();
                if (!(_this4.busy || delistBtn.disabled)) {
                  _context.n = 1;
                  break;
                }
                return _context.a(2);
              case 1:
                _this4.busy = true;
                delistBtn.disabled = true;
                _context.p = 2;
                _context.n = 3;
                return _this4.submitDelist();
              case 3:
                _context.n = 5;
                break;
              case 4:
                _context.p = 4;
                _t = _context.v;
                console.error('Store: delist failed', _t);
                if (typeof siteMessage === 'function') {
                  siteMessage((_t === null || _t === void 0 ? void 0 : _t.message) || 'Delist failed', 4000);
                }
                delistBtn.disabled = false;
                _this4.busy = false;
              case 5:
                return _context.a(2);
            }
          }, _callee, null, [[2, 4]]);
        }));
        return function (_x) {
          return _ref3.apply(this, arguments);
        };
      }();
    }
  }, {
    key: "submitDelist",
    value: function () {
      var _submitDelist = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var _summary$returnTitle2;
        var summary, listing_row, listing_tx, tx, title;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              summary = this.summary;
              if (!(!(summary instanceof Summary) || !summary.listing_signature)) {
                _context2.n = 1;
                break;
              }
              throw new Error('Listing is unavailable');
            case 1:
              _context2.n = 2;
              return loadListingSpend(this.app, this.mod, summary.listing_signature);
            case 2:
              listing_row = _context2.v;
              listing_tx = summary.listing_tx || null;
              if (listing_tx) {
                _context2.n = 4;
                break;
              }
              _context2.n = 3;
              return loadTransactionFromArchive(this.app, summary.listing_signature);
            case 3:
              listing_tx = _context2.v;
            case 4:
              _context2.n = 5;
              return this.mod.createDelistAssetTransaction(listing_row, listing_tx);
            case 5:
              tx = _context2.v;
              this.app.network.propagateTransaction(tx);
              title = ((_summary$returnTitle2 = summary.returnTitle) === null || _summary$returnTitle2 === void 0 ? void 0 : _summary$returnTitle2.call(summary)) || summary.title || 'Listing';
              this.overlay.close();
              this.watchDelist(tx, title, summary);
            case 6:
              return _context2.a(2);
          }
        }, _callee2, this);
      }));
      function submitDelist() {
        return _submitDelist.apply(this, arguments);
      }
      return submitDelist;
    }()
  }, {
    key: "watchDelist",
    value: function watchDelist(tx) {
      var _this5 = this;
      var listingTitle = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      var summary = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      if (!(tx !== null && tx !== void 0 && tx.signature)) {
        throw new Error('Delist requires a signed transaction');
      }
      if (!this.mod.transaction_monitor) {
        throw new Error('transaction_monitor is not initialized');
      }
      var lead = listingTitle ? "Delisting ".concat(listingTitle, " and returning the NFT to your wallet.") : 'Delisting this asset and returning the NFT to your wallet.';
      this.mod.transaction_monitor.render({
        tx: tx,
        title: 'Delisting Asset',
        lead: lead,
        subtitle: 'Waiting for confirmation...',
        auto_continue_on_confirm: true,
        callback: function callback(result) {
          _this5.busy = false;
          if ((result === null || result === void 0 ? void 0 : result.status) === 'confirmed') {
            _this5.onDelistConfirmed(summary);
          }
        }
      });
    }
  }, {
    key: "onStoreDelistAsset",
    value: function onStoreDelistAsset() {
      var _ref4 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        conf = _ref4.conf,
        tx = _ref4.tx;
      if (Number(conf) !== 0 || !(tx !== null && tx !== void 0 && tx.signature)) {
        return;
      }
      // Monitor callback owns refresh when this client broadcast the delist.
    }
  }, {
    key: "onDelistConfirmed",
    value: function onDelistConfirmed() {
      var _this$mod$main, _storefront$isAdminAc, _this$app$wallet;
      var summary = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.summary;
      if (typeof siteMessage === 'function') {
        var _summary$returnTitle3;
        var title = (summary === null || summary === void 0 || (_summary$returnTitle3 = summary.returnTitle) === null || _summary$returnTitle3 === void 0 ? void 0 : _summary$returnTitle3.call(summary)) || (summary === null || summary === void 0 ? void 0 : summary.title) || 'Listing';
        siteMessage("Delisted: ".concat(title), 4000);
      }
      var storefront = (_this$mod$main = this.mod.main) === null || _this$mod$main === void 0 || (_this$mod$main = _this$mod$main.manager) === null || _this$mod$main === void 0 ? void 0 : _this$mod$main.storefront;
      if (storefront !== null && storefront !== void 0 && (_storefront$isAdminAc = storefront.isAdminActive) !== null && _storefront$isAdminAc !== void 0 && _storefront$isAdminAc.call(storefront)) {
        void storefront.loadAdminPage({
          page: storefront.page || 1
        });
      } else if (storefront !== null && storefront !== void 0 && storefront.reloadInventory) {
        void storefront.reloadInventory();
      }
      this.app.connection.emit('saito-nft-list-render-request');
      if (typeof ((_this$app$wallet = this.app.wallet) === null || _this$app$wallet === void 0 ? void 0 : _this$app$wallet.updateNFTList) === 'function') {
        void this.app.wallet.updateNFTList();
      }
    }
  }]);
}();
module.exports = DelistOverlay;